import { Product } from '@framework/types';
import { PRODUCT_SEEN } from '@lib/constants';
import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import dayjs from 'dayjs';

export const defaultProduct: Product[] = [];

export const productSeenStorageAtom = atomWithStorage(PRODUCT_SEEN, defaultProduct);

export const productSeenAtom = atom(
  (get) => {
    const products = get(productSeenStorageAtom);
    return products.filter(item => dayjs().diff(item.expired_at) < 0);
  },
  (get, set, product: any) => {
    const prev = get(productSeenStorageAtom);
    const prevFilter = prev.filter(item => item.id != product.id && dayjs().diff(item.expired_at) < 0);

    return set(productSeenStorageAtom, [...prevFilter, product]);
  }
);
